module.exports = __webpack_public_path__ + "static/product-intro-block-background-5d848d6334dbb0851af3a3a9ae8ea99a.jpg";